import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { dateReportFormatter } from "../../fomatters/DateFormatter";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function SignUp() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [agent, setAgent] = useState("");
  const onAgentChanged = useCallback(
    (event) => setAgent(event.target.value),
    []
  );

  const [affiliate, setAffiliate] = useState("");
  const onAffiliateChanged = useCallback(
    (event) => setAffiliate(event.target.value),
    []
  );

  const [orderBy, setOrderBy] = useState(0);
  const onOrderByChange = useCallback(
    (event) => setOrderBy(Number(event.target.value)),
    []
  );

  const [onlyTrans, setOnlyTrans] = useState(0);
  const onOnlyTransChange = useCallback(
    (event) => setOnlyTrans(Number(event.target.value)),
    []
  );

  const [source, setSource] = useState(0);
  const onSourceChanged = useCallback(
    (event) => setSource(Number(event.target.value)),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  const [sourceDesc, setSourceDesc] = useState("");
  const onSourceDescChanged = useCallback((s) => setSourceDesc(s), []);
  const { values: sources } = useDataFormatterHook({
    addEmpty: true,
    value: "sourceName",
    text: "sourceName",
    path: `/Player/Source_GetList`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          className="flex-1"
          required
          variant="outlined"
          id="gameDateTime"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Agent"
          type="text"
          value={agent}
          size="small"
          onChange={onAgentChanged}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Affiliate"
          type="text"
          value={affiliate}
          size="small"
          onChange={onAffiliateChanged}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Source"
          name="name"
          data={sources}
          placeholder="DataFormatter"
          setSelectValue={onSourceDescChanged}
          startValue={""}
        />
        <div>
          <SubGroup title="Order By">
            <FormControl component="fieldset">
              <RadioGroup label value={orderBy} onChange={onOrderByChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Creation Date"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Player"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Sign Up">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={onlyTrans}
                onChange={onOnlyTransChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="All"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Deposits"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="No Deposits"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div>
          <SubGroup title="Source">
            <FormControl component="fieldset">
              <RadioGroup label value={source} onChange={onSourceChanged} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Both"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Local"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="OnLine"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Sign Up Report"
        groupBy={onlyTrans < 2 ? "key" : null}
        getUrl={() => "/Reports/Report_SignUp_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Book: book,
          Office: office,
          Agent: agent,
          Affiliate: affiliate,
          SourceDesc: sourceDesc,
          OrderBy: orderBy,
          OnlyTrans: onlyTrans,
          Source: source,
        })}
        getGroupOrders={[(key, items) => items[0]?.orderDate.getTime()]}
        getPreProcess={(data) => {
          if (onlyTrans === 2) return data;
          const grouped = {};
          let group = [];
          data.forEach((item, index) => {
            group.push(item);
            if (
              item.description ||
              (!item.description && index === data.length - 1)
            ) {
              const lastModification = new Date(
                item.lastModification
              ).toDateString();

              const key = item.description
                ? `${lastModification} - ${item.description} - ${item.paymentMethod}`
                : "No Deposits";
              grouped[key] = group.map((groupedItem) => {
                const signUpDate = new Date(
                  groupedItem.singUpDate
                ).toGMTString();

                return {
                  ...groupedItem,
                  orderDate: new Date(item.lastModification),
                  creationDate: `Create On: ${signUpDate}`,
                  createBy: `Create By: ${groupedItem.loginName}`,
                  total:
                    groupedItem.amount + groupedItem.fee + groupedItem.bonus,
                  key: key,
                };
              });
              group = [];
            }
          });

          const items = Object.values(grouped).flat(Infinity);
          return items;
        }}
        getTotals={(data) => {
          if (onlyTrans === 2) {
            return {
              creationDate: `${data.length} Player(s)`,
              createBy: `Total`,
            };
          } else {
            return {
              createBy: "Total by Player",
              amount: data.reduce((acc, item) => acc + item.amount, 0),
              fee: data.reduce((acc, item) => acc + item.fee, 0),
              bonus: data.reduce((acc, item) => acc + item.bonus, 0),
              total: data.reduce((acc, item) => acc + item.total, 0),
            };
          }
        }}
        getGlobalTotals={(data) => {
          return {
            creationDate: `${data.length} Player(s)`,
            createBy: `Total`,
            amount: data.reduce((acc, item) => acc + item.amount, 0),
            fee: data.reduce((acc, item) => acc + item.fee, 0),
            bonus: data.reduce((acc, item) => acc + item.bonus, 0),
            total: data.reduce((acc, item) => acc + item.total, 0),
          };
        }}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Account
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="name">
          Name
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="lastName">
          Last Name
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="creationDate"
          dataFormat={dateReportFormatter}
        >
          Creation Date
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="createBy">
          Create By
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="amount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Cash
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="fee"
          dataFormat={decimalInvertedReportFormatter}
        >
          Fee
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="bonus"
          dataFormat={decimalInvertedReportFormatter}
        >
          Bonus
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="total"
          dataFormat={decimalInvertedReportFormatter}
        >
          Total
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default SignUp;
